// Shopify is the content source for the approved draft-product collection.
(() => {
  const list=window.shopCatalogue;
  if(!list)return;
  const allConfigs=window.linxManagedProducts||[];
  const configs=allConfigs.filter(c=>c.published&&c.published.managedBy==='shopify');
  const routes=new Map(configs.map(c=>[c.handle,c.productUrl]));
  const managed=new Set(allConfigs.map(c=>c.handle));
  for(let i=list.length-1;i>=0;i--)if(managed.has(list[i].id))list.splice(i,1);
  function apply(p,handle){
    if(!p||p.managedBy!=='shopify'||p.id!==handle)throw Error('Product data unavailable: '+handle);
    const prices=p.variants.map(v=>v.price).filter(Number.isFinite);
    if(p.pricingStatus!=='pending'&&prices.length)p.price=new Intl.NumberFormat('en-CA',{style:'currency',currency:p.priceCurrency||'CAD',currencyDisplay:p.priceCurrency&&p.priceCurrency!=='CAD'?'code':'symbol'}).format(Math.min(...prices)/100);
    const at=list.findIndex(x=>x.id===handle);
    if(at>=0)list.splice(at,1,p);else list.push(p);
    return p;
  }
  const native=window.linxNativeProduct;
  if(native)apply(native,native.id);
  function refresh(p){
    document.querySelectorAll(`[data-product-handle="${p.id}"]`).forEach(card=>{
      const title=card.querySelector('.grid-product__title');if(title)title.textContent=p.name;
      const price=card.querySelector('.grid-product__price');if(price){price.toggleAttribute('data-native-money',Boolean(p.priceCurrency&&p.priceCurrency!=='CAD'));price.textContent=p.price;}
      card.querySelectorAll('img').forEach((img,i)=>{img.src=p.images[i]||p.image;img.removeAttribute('srcset')});
      const quick=card.querySelector('.quick-product__btn');if(quick)quick.onclick=e=>{e.preventDefault();openOriginalQuick(p)};
    });
  }
  const requested=native?.id||new URLSearchParams(location.search).get('id');
  const promises=configs.map(async c=>{
    try{
      const initial=native?.id===c.handle?native:c.published;
      const p=apply(initial,c.handle);
      refresh(p);
      if(requested===c.handle&&window.renderLinxProduct)window.renderLinxProduct();
      return p;
    }catch(error){
      if(requested===c.handle){const root=document.querySelector('#product-detail');if(root)root.innerHTML='<p role="status">This product is currently unavailable. Please try again shortly.</p>';}
      return null;
    }
  });
  // Retain the readiness hook used by preview search and quick view.
  window.linxMkpReady=Promise.all(promises).then(products=>{
    if(typeof renderShop==='function'&&document.querySelector('#shop-products'))renderShop();
    products.filter(Boolean).forEach(refresh);
    return products;
  });
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');if(!link)return;
    const url=new URL(link.href,location.href);
    const handle=url.pathname==='/pages/product-preview'?url.searchParams.get('id'):null;
    if(handle&&routes.has(handle))link.href=routes.get(handle);
  },true);
})();
